// frontend/src/components/atoms/CustomImage/index.js

function CustomImage(props) {
    return <img alt="" {...props} />;
}

export default CustomImage;